import { put, destroy } from 'app/shared/utils/fetchr';

// Models
import { EditNarrativePayload } from 'app/modules/narratives/requests';
import { Narrative } from 'app/modules/narratives/models';

export const editNarrativeApi = (
  payload: EditNarrativePayload,
): Promise<Narrative> => {
  return put('/narratives', payload);
};

export const deleteNarrativeApi = (id: string): Promise<Narrative> => {
  return destroy('/narratives/:id'.replace(':id', id));
};
